<template>
  <div class="main-layout">
    <navbar />
      <!-- if the user is a teacher -->
    <div
        v-if="user.teacher === 1 || user.admin === 1"
        id="home"
        class="main class-page sidebar-space"
    >
      <!--Custom Breadcrumbs-->
      <b-container fluid class="d-flex flex-column h-100" v-if="!loading">
        <br>
        <div>
          <router-link
          v-if="user.teacher === 1"
          class="inline text-home-primary clickable"
          :to="{ name: 'teacher' }"
          >
          My Classes
          </router-link>
          <router-link class="inline text-home-primary clickable" v-else-if="user.admin === 1" @click="close">Close Class Page</router-link>
          <p v-if="selectedPageMode === 'members'" class="inline text-home-primary"> > {{ this.classData.name }}</p>
          <span v-else-if="selectedPageMode === 'groups'">
          >
          <router-link class="inline text-home-primary clickable" :to="{path: '/class/members'}"> {{ this.classData.name }} </router-link>
          <p class="inline"> > Group View</p>
          </span>
          <span v-else-if="selectedPageMode === 'individual.student'">
          >
          <router-link class="inline text-home-primary clickable" :to="{path: '/class/members'}"> {{ this.classData.name }} </router-link>
          <span v-if="this.pcsSelect.group_based && classViewMode === 'groups'"> > <router-link class="inline text-home-primary clickable" :to="{path: '/class/groups'}" > Group View </router-link></span>
          <p class="inline" v-if="individualStudent"> > {{individualStudent.name}}</p>
          </span>
          <span v-else-if="selectedPageMode === 'individual.group'">
          >
          <router-link class="inline text-home-primary clickable" :to="{path: '/class/members'}"> {{ this.classData.name }} </router-link>
          <span> > <router-link class="inline text-home-primary clickable" :to="{path: '/class/groups'}" > Group View </router-link></span>
          <p class="inline"> > {{individualGroup.name || defaultGroupName(individualGroup.group_id)}}</p>
          </span>
        </div>
        <br />
        <b-row>
          <b-col>
            <h2><b>{{ this.classData.name }}</b></h2>
          </b-col>
          <b-col class="align-right">
            <h2>{{ this.pcsSelect.name }}</h2>
          </b-col>
        </b-row>
        
        <TeacherSideBar/>
        <child :key="$route.fullPath"/>
      </b-container>
      <b-container v-else class="d-flex justify-content-center pt-3">
        <b-spinner label="Loading..."></b-spinner>
      </b-container>
    </div>
    <!-- if the user is not a teacher -->
    <div v-else id="pcs">
        <h3>Your user does not have access to the teacher content</h3>
    </div>
  </div>
</template>

<script>
import Navbar from '~/components/Navbar'
import TeacherSideBar from '~/pages/modules/admin/classComponents/TeacherSideBar'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'TeacherClassLayout',

  components: {
    Navbar,
    TeacherSideBar,
  },
  created: function () {
    this.loadClassData(this)
  },
  computed: {
    ...mapState('teacherClass', [
      'loading', 
      'classData', 
      'pcsSelect',
      'selectedPageMode',
      'selectedGroupMode', 
      'individualStudent',
      'individualGroup',
      'students',
      'classViewMode',
      ]),
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  methods: {
    ...mapActions('teacherClass', ['loadClassData', 'getGroupName']),
    defaultGroupName: function(groupId) {
      return `Group ${
        this.students.groups.findIndex((group) => group.group_id === groupId) + 1
      }`
    },
  },
}
</script>
<style scoped lang="scss">
.class-page::v-deep {
  @import   '../pages/modules/admin/classComponents/teacherPanel.scss';
}
.sidebar-space {
  padding-left: 260px;
}

#pcs {
  list-style-type: none;
  padding-left: 0;
}

#pcs > li {
  width: 20em;
  display: inline-block;
  margin: 1em;
  margin-left: 0;
}
.clickable:hover {
    cursor: pointer;
}

.text-decoration-underline {
  text-decoration: underline !important;
}
.main {
  position: absolute;
  left: 0;
  right: 0;
  top: 55px;
  bottom: 0;
  background-color: #f6f6f6;
}
</style>
